import React from 'react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center text-white">
      <h1 className="text-6xl font-extrabold font-serif">404</h1>
      <p className="text-sm text-slate-400 mt-2">Trang bạn tìm kiếm không tồn tại.</p>
      <a href="/" className="mt-6 px-6 py-2.5 bg-indigo-600 text-xs font-bold rounded-xl">
        Trở Về Trang Chủ
      </a>
    </div>
  );
}